const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReplay10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.99,4.68V0l-5.85,5.85,5.85,5.85v-4.68c3.87,0,7.02,3.15,7.02,7.02s-3.15,7.02-7.02,7.02-7.02-3.15-7.02-7.02h-2.34c0,5.17,4.19,9.36,9.36,9.36s9.36-4.19,9.36-9.36-4.19-9.36-9.36-9.36Z",
    style: {
      fill: "currentColor",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.7,17.55h-.99v-3.81l-1.18.36v-.81l2.07-.74h.11v4.99Z",
    style: {
      fill: "currentColor",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.71,15.49c0,.37-.04.7-.12.96s-.2.49-.34.67-.33.3-.53.39-.43.12-.69.12-.48-.04-.69-.12-.39-.21-.54-.39-.27-.4-.35-.67-.13-.58-.13-.96v-.87c0-.37.04-.7.12-.96s.2-.49.34-.67.33-.3.53-.39.43-.12.69-.12.48.04.69.12c.21.08.39.21.54.39s.27.4.35.67.13.58.13.96v.87ZM14.72,14.48c0-.22-.01-.41-.05-.56s-.08-.27-.14-.36-.13-.16-.22-.2-.19-.06-.29-.06-.21.02-.29.06-.16.11-.22.2-.11.21-.14.36-.05.34-.05.56v1.13c0,.22.01.41.05.56s.08.28.14.37.13.16.22.2.19.06.29.06.21-.02.29-.06.16-.11.22-.2.11-.22.13-.37.05-.34.05-.56v-1.13h.01Z",
    style: {
      fill: "currentColor",
      strokeWidth: 0
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay10);
export default __webpack_public_path__ + "static/media/replay10.21a5680ac984b32e9b766aaccfe28fe0.svg";
export { ForwardRef as ReactComponent };